import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { PageComponent } from './page/page.component';

import {APP_BASE_HREF} from '@angular/common'; 
import { AppComponent } from '../../app.component';


// share
import {ErpMaterialModule} from '../../material-module';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs'; 
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ComfunctModule} from '../.././common/comfunct/comfunct.module';

//translation
import {HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgxPrintModule} from 'ngx-print';
import { SharedModule } from 'src/app/shared/shared.module';


export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
 }

@NgModule({
  declarations: [PageComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    BrowserModule,
    ErpMaterialModule, 
    NgSelectModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    MatTabsModule,
    MatSelectModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ComfunctModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }) 
  ],
  providers: [{provide: APP_BASE_HREF, useValue : '/' }] ,
  bootstrap: [AppComponent]
  
  
})
export class DashboardModule { }
